export enum EOperationType {
  onboarding = 'onboarding',
  account = 'account'
}